import type { DocNode } from '@atlaskit/adf-schema';
import { defaultSchema } from '@atlaskit/adf-schema/schema-default';
import { ConfluenceTransformer } from '@atlaskit/editor-confluence-transformer';
import { JSONTransformer } from '@atlaskit/editor-json-transformer';

const htmlPmNodeTransformer = new ConfluenceTransformer(defaultSchema);
const pmNodeADFTransformer = new JSONTransformer(defaultSchema);

/**
 * Creates a placeholder ADF from HTML.
 * This is because we need to provide translations in HTML to be supported and we convert back to ADF here
 * See: https://developer.atlassian.com/platform/localization/i18n-formatting/avoiding-concatenation/
 */
export const createPlaceholderADF = (html: string): DocNode => {
	const pmNode = htmlPmNodeTransformer.parse(html);
	return pmNodeADFTransformer.encode(pmNode) as DocNode;
};
